var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('agile-table',{attrs:{"data":_vm.invoices,"data-type":_vm.dataType,"table-meta":_vm.tableMeta,"filter-meta":_vm.filterMeta,"action-meta":_vm.actionMeta,"column-meta":_vm.columnMeta},on:{"rowAction":_vm.rowAction,"fieldAction":_vm.fieldAction,"tableAction":_vm.tableAction}}),_vm._v(" "),_c('slideout-panel')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b48aaf80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Admin/Invoices/InvoiceArchivePage.vue
// module id = null
// module chunks = 